import { render, staticRenderFns } from "./NormalSearchNav54.vue?vue&type=template&id=12bf59b0&scoped=true&"
import script from "./NormalSearchNav54.vue?vue&type=script&lang=js&"
export * from "./NormalSearchNav54.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12bf59b0",
  null
  
)

export default component.exports